module.exports = __webpack_public_path__ + "img/acumula.164a3bd5.svg";